import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import MultipleTooltip from "../MultipleTooltip";
import cross from './assets/Cross.svg';
import classnames from 'classnames';
import styles from './styles.module.scss';
import inputStyles from '../../styles/commonInput.module.scss';
import {toAbsoluteUrl} from "../../../../../_metronic/_helpers";

export const StyledFieldEmailChips = ({
                                        fieldId,
                                        type = 'text',
                                        label = null,
                                        customContainerStyles = null,
                                        customLabelStyles = null,
                                        customInputStyles = null,
                                        setFieldValue,
                                        customerEmails,
                                        ...rest
                                      }) => {
  const [items, setItems] = useState([...customerEmails]);
  const [value, setValue] = useState('');
  const [error, setError] = useState([]);
  const intl = useIntl();

  const isInList = (email) => {
    return items.includes(email);
  }

  const isEmail = (email) => {
    return /[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/.test(email);
  }

  const isValid = (email, items) => {
    let error = null;

    if (isInList(email)) {
      error = `${email} ${intl.formatMessage({
        id: 'customer-details-popup-create-document-error-already-added-email',
        defaultMessage: 'Email has already added!',
      })}`;
    }

    if (!isEmail(email)) {
      error = `${email} ${intl.formatMessage({
        id: 'customer-details-popup-create-document-error-no-more-emails-required',
        defaultMessage: 'No more emails required!',
      })}`;
    }

    if (items.length > 4) {
      error = `${intl.formatMessage({
        id: 'customer-details-popup-create-document-error-no-more-emails-required',
        defaultMessage: 'No more emails required!',
      })}`
    }

    if (error) {
      setError(error);

      return false;
    }

    return true;
  }

  const handleKeyDown = e => {
    if (["Enter", "Tab", ","].includes(e.key)) {
      e.preventDefault();
      let trimmedValue = value.trim();

      if (trimmedValue && isValid(value, items)) {
        setItems([...items, trimmedValue]);
        setValue('');
        setFieldValue(fieldId, [...items, trimmedValue]);
      }
    }
  };
  const handleBlur = e => {
    e.preventDefault();
    let trimmedValue = value.trim();
    if (trimmedValue && isValid(value, items)) {
      setItems([...items, trimmedValue]);
      setValue('');
      setFieldValue(fieldId, [...items, trimmedValue]);
    }
  };

  const handleChange = e => {
    setValue(e.target.value);
    setError(null);
  };

  const handleDelete = item => {
    setItems(items.filter(i => i !== item))
    setFieldValue(fieldId, items.filter(i => i !== item));
  };

  const handlePaste = e => {
    e.preventDefault();

    let paste = e.clipboardData.getData("text");
    let emails = paste.match(/[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/g);

    if (emails) {
      let toBeAdded = emails.filter(email => !isInList(email));
      setItems([...items, ...toBeAdded]);
    }
  };

  return (
    <div className={styles.styledFieldEmailChipsContainer}>
      <label className={classnames(styles.inputContainer, customContainerStyles)}>
        <div className={classnames(styles.labelContainer, customLabelStyles)}>
          {label}
          <MultipleTooltip
            id={'emails'}
            label={'להוספת כתובות אימייל, הזינו את הכתובת וליחצו אנטר או טאב'}
            customIconClassName={'position-static mx-2'}
          />
        </div>
        <div className={styles.inputWithIconContainer}>
          <input
            className={classnames(inputStyles.input, 'text-left', customInputStyles)}
            id={fieldId}
            type={type}
            onKeyDown={handleKeyDown}
            onChange={handleChange}
            onPaste={handlePaste}
            onBlur={handleBlur}
            value={value}
            dir={'ltr'}
            {...rest}
          />
          <img src={toAbsoluteUrl('/media/common/Email_primary.svg')} className={styles.icon} alt="i"/>
        </div>
      </label>
      {error && <p className={styles.error}>{error}</p>}
      <div className={styles.tagItemContainer}>
        {items.map(item => (
          <div className={styles.tagItem} key={item}>
            <div dir={'ltr'}>{item}</div>
            <div
              className={styles.removeButton}
              onClick={() => handleDelete(item)}
            >
              <img className={styles.removeIcon} src={cross} alt="remove"/>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StyledFieldEmailChips;
